import _ from 'lodash';

const generateId = (length = 5) => {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;

  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

const shortText = (state) => {
  const updatedState = _.cloneDeep(state);

  const {
    form
  } = updatedState;

  const id = generateId();
  
  const newElement = {
    id,
    type: 'string',
    title: 'New question',
    description: '',
    default: ''
  };

  form.JSONSchema.properties[id] = newElement;
  form.UISchema['ui:order'].push(id);
  updatedState.selectedElement = { ...newElement };

  return updatedState;
};

const paragraph = (state) => {
  const updatedState = _.cloneDeep(state);

  const {
    form
  } = updatedState;

  const id = generateId();
  
  const newElement = {
    id,
    type: 'string',
    title: 'New question',
    description: '',
    default: '',
    format: 'textarea'
  };

  form.JSONSchema.properties[id] = newElement;
  form.UISchema['ui:order'].push(id);
  updatedState.selectedElement = { ...newElement };

  return updatedState;
};

const number = (state) => {
  const updatedState = _.cloneDeep(state);

  const {
    form
  } = updatedState;

  const id = generateId();
  
  const newElement = {
    id,
    type: 'integer',
    title: 'New question',
    description: '',
    default: 0
  };

  form.JSONSchema.properties[id] = newElement;
  form.UISchema['ui:order'].push(id);
  updatedState.selectedElement = { ...newElement };

  return updatedState;
};

const date = (state) => {
  const updatedState = _.cloneDeep(state);

  const {
    form
  } = updatedState;

  const id = generateId();
  
  const newElement = {
    id,
    type: 'string',
    title: 'New question',
    description: '',
    format: 'date-time'
  };

  form.JSONSchema.properties[id] = newElement;
  form.UISchema['ui:order'].push(id);
  updatedState.selectedElement = { ...newElement };

  return updatedState;
};

const multipleChoice = (state) => {
  const updatedState = _.cloneDeep(state);

  const {
    form
  } = updatedState;

  const id = generateId();
  
  const newElement = {
    id,
    type: 'string',
    title: 'New select field',
    description: '',
    enum: [
      'Option 1',
      'Option 2'
    ],
    default: 'Option 1'
  };

  form.JSONSchema.properties[id] = newElement;
  form.UISchema['ui:order'].push(id);
  updatedState.selectedElement = { ...newElement };

  return updatedState;
};

const attachment = (state) => {
  const updatedState = _.cloneDeep(state);

  const {
    form
  } = updatedState;

  const id = generateId();
  
  const newElement = {
    id,
    type: 'string',
    title: 'New file field',
    description: '',
    format: 'data-url'
  };

  form.JSONSchema.properties[id] = newElement;
  form.UISchema['ui:order'].push(id);
  updatedState.selectedElement = { ...newElement };

  return updatedState;
};

const generateElementStrategies = {
  shortText,
  paragraph,
  number,
  date,
  multipleChoice,
  attachment
};

export default generateElementStrategies;
